var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLockLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 10.875H19.1667V7.25C19.1667 3.25163 15.7282 0 11.5 0C7.27183 0 3.83333 3.25163 3.83333 7.25V10.875H2.875C1.29056 10.875 0 12.0942 0 13.5938V26.2812C0 27.7808 1.29056 29 2.875 29H20.125C21.7094 29 23 27.7808 23 26.2812V13.5938C23 12.0942 21.7094 10.875 20.125 10.875ZM6.38889 7.25C6.38889 4.58442 8.68122 2.41667 11.5 2.41667C14.3188 2.41667 16.6111 4.58442 16.6111 7.25V10.875H6.38889V7.25ZM12.7778 20.2058V22.9583C12.7778 23.6253 12.2066 24.1667 11.5 24.1667C10.7934 24.1667 10.2222 23.6253 10.2222 22.9583V20.2058C9.46194 19.7865 8.94444 19.0155 8.94444 18.125C8.94444 16.7922 10.0906 15.7083 11.5 15.7083C12.9094 15.7083 14.0556 16.7922 14.0556 18.125C14.0556 19.0155 13.5381 19.7865 12.7778 20.2058Z",
    fill: "#30333A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockLg);
export default __webpack_public_path__ + "static/media/icon-lock-lg.0376d7a51a7b68cf088094c6fd46c836.svg";
export { ForwardRef as ReactComponent };